export const  scaleImage: (imageUrl: string, deviceWidth: number, scalingMultiplier: number) => string = (imageUrl, deviceWidth, scalingMultiplier) => {
    if (!imageUrl) {
        return;
    }
    return imageUrl?.split('?')?.[0] + `?w=${deviceWidth * scalingMultiplier}&mw=${deviceWidth * scalingMultiplier}`
}

export const getScaledHeight: (imageHeight: number, imageWidth: number, deviceWidth: number, scalingMultiplier: number) => number = (imageHeight, imageWidth, deviceWidth, scalingMultiplier) => {
    const coefficient = imageHeight / imageWidth
    return Math.floor((deviceWidth * coefficient) * scalingMultiplier)
}